<template>
  <div style="margin-top: 10px">
    <!--
      <div>
        <input type="number" v-model.number="centerLat" placeholder="Enter latitude" />
        <input type="number" v-model.number="centerLng" placeholder="Enter longitude" />
        <button @click="updateGeofenceCenter">Update Geofence Center</button>
      </div>
      <input type="text" v-model="address" placeholder="Enter an address" />
      <button @click="checkAddress">Check if within geofence</button>
      -->
    <div id="map" style="height: 200px; display: none"></div>
    <v-alert
      v-if="addressCheckResult !== null"
      :type="addressCheckResult ? 'success' : 'error'"
      class="w-100 mt-4"
    >
      {{
        addressCheckResult
          ? "The address is within the allowed radius."
          : "The address is outside the allowed radius."
      }}
    </v-alert>
  </div>
</template>

<script>
/* global MQ */
import L from "leaflet";
import "leaflet/dist/leaflet.css";
const quest_api = require("../client_config/config").quest_api;

// Define the custom marker icon
/*
const customIcon = new L.Icon({
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  shadowSize: [41, 41]
});
*/

export default {
  name: "GeoFence",
  props: {
    initialCenterLat: {
      type: Number,
      default: 0,
      required: true,
    },
    initialCenterLng: {
      type: Number,
      default: 0,
      required: true,
    },
    geofenceRadiusFeet: {
      type: Number,
      required: true,
      default: 20, // Default to 20 feet
    },
    programAddress: {
      type: String,
      required: true,
      default: "US",
    },
    searchAddress: {
      type: String,
      required: true,
    },
    streetCurrent: {
      type: String,
    },
  },
  data() {
    return {
      map: null,
      circle: null,
      address: this.programAddress,
      useSearchAddress: this.searchAddress,
      currentStreet: this.streetCurrent,
      centerLat: this.initialCenterLat,
      centerLng: this.initialCenterLng,
      geofenceRadius: this.geofenceRadiusFeet * 0.3048, // Convert feet to meters
      addressCheckResult: null,
      isComponentActive: true,
    };
  },

  async created() {
    await this.loadMap();
    await this.checkAddress();
  },

  beforeDestroy() {
    this.isComponentActive = false;
    if (this.map) {
      this.map.remove();
    }
  },

  methods: {
    async loadMap() {
      try {
        if (this.isComponentActive) {
          await this.loadScript(
            `https://www.mapquestapi.com/sdk/leaflet/v2.2/mq-map.js?key=${quest_api}`
          );
          this.initMap();
        }
      } catch (error) {
        console.error("Failed to load MapQuest SDK:", error);
      }
    },

    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () =>
          reject(new Error(`Failed to load script: ${src}`));
        document.head.appendChild(script);
      });
    },

    initMap() {
      if (typeof MQ !== "undefined") {
        this.map = L.map("map", {
          layers: MQ.mapLayer(),
          center: [this.centerLat, this.centerLng],
          zoom: 16,
        });

        this.circle = L.circle([this.centerLat, this.centerLng], {
          color: "red",
          fillColor: "#f03",
          fillOpacity: 0.5,
          radius: this.geofenceRadius,
        }).addTo(this.map);

        // Uncomment and implement checkGeofence method if needed
        // this.map.on('click', this.checkGeofence);
      } else {
        console.error("MapQuest SDK not loaded.");
      }
    },

    checkGeofence(e) {
      const distance = this.map.distance(e.latlng, {
        lat: this.centerLat,
        lng: this.centerLng,
      });
      if (distance > this.geofenceRadius) {
        alert("You are outside the allowed radius!");
      } else {
        alert("You are within the allowed radius.");
      }
    },

    async checkAddress() {
      console.log(this.useSearchAddress);
      if (this.map === null) {
        await this.loadMap();
      }
      if (!this.address) {
        alert("Please enter an address.");
        return;
      }
      try {
        const geocodeUrl = `https://www.mapquestapi.com/geocoding/v1/address?key=${quest_api}&location=${encodeURIComponent(
          this.address
        )}`;
        const response = await fetch(geocodeUrl);
        const data = await response.json();

        if (
          data.results &&
          data.results[0].locations &&
          data.results[0].locations.length > 0
        ) {
          const location = data.results[0].locations[0];
          const isWithinGeofence = this.checkIfWithinGeofence(location);

          this.addressCheckResult = isWithinGeofence;
          const result = {
            isWithinGeofence: isWithinGeofence,
            location: location?.latLng?.lat + ", " + location?.latLng?.lng,
          };
          this.$emit("address-checked", result);
          return isWithinGeofence;
        } else {
          alert("Address not found.");
          return false;
        }
      } catch (error) {
        console.error("Geocoding error:", error);
        alert("Error occurred while geocoding the address.");
        return false;
      }
    },

    checkIfWithinGeofence(location) {
      console.log(this.currentStreet);
      const distance = this.map.distance(location?.latLng, {
        lat: this.centerLat,
        lng: this.centerLng,
      });

      console.log(distance);
      let isWithinGeofence = false;

      if (
        distance <= this.geofenceRadius ||
        this.currentStreet == this.address
      ) {
        isWithinGeofence = true;
      } else {
        isWithinGeofence = false;
      }
      /*
        this.map.setView([location.lat, location.lng], 20);
        this.circle.setLatLng([location.lat, location.lng]);

        console.log("ERROR:" + location)
        // Add a marker for the current location
        L.marker([this.centerLat, this.centerLng], { icon: customIcon }).addTo(this.map)
              .bindPopup('You are here')
              .openPopup();
        */

      return isWithinGeofence;
    },
    updateGeofenceCenter() {
      this.map.setView([this.centerLat, this.centerLng], 20);
      this.circle.setLatLng([this.centerLat, this.centerLng]);
    },
  },
};
</script>

<style>
#map {
  width: 100%;
  height: 100%;
}
</style>
